// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"b2f18068","393":"927272dc","453":"02ddda0e","572":"5a8bc5c7"}[chunkId] + ".chunk.js";
};